<form *ngIf="editRequestsForm && positions?.length"
      clrForm
      [formGroup]="editRequestsForm">
  <table class="table" id="positionsTable">
    <thead>
    <tr>
      <th class="left">Position</th>
      <th class="left">Bezeichnung</th>
      <th class="left">Zeichnungsnummer</th>
      <th class="left">Material</th>
      <th class="left">Gewicht (in kg)</th>
      <th class="left">Kennzeichnung</th>
      <th class="left">Chargen-Nr.</th>
      <th class="left">Kostenstelle</th>
      <th>Anzahl</th>
      <th>Angebot in EUR</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr>
      <td>{{ editPosition }}<span *ngIf="editPart !== 0">.{{ editPart }}</span></td>
      <td class="left"><b>
        {{ positions[0].name }}</b>
        <span *ngIf="((!positions[0].description) || (positions[0].description.length > 0))"><br />{{ positions[0].description }}</span></td>
      <td class="left">{{ positions[0].technical_drawing }}</td>
      <td class="left">{{ positions[0].material }}</td>
      <td class="left"><input type="text" formControlName="weight" placeholder="{{ positions[0].weight }} " class="clr-input" value="{{ positions[0].weight }} "></td>
      <td class="left"><input type="text" formControlName="serial_nr" placeholder="{{ positions[0].serial_nr }} " class="clr-input" value="{{ positions[0].serial_nr }} "></td>
      <td class="left"><input type="text" formControlName="heat_nr" placeholder="{{ positions[0].heat_nr }} " class="clr-input" value="{{ positions[0].heat_nr }} "></td>
      <td class="left"><input type="text" formControlName="controlling_nr" placeholder="{{ positions[0].controlling_nr }} " class="clr-input" value="{{ positions[0].controlling_nr }} "></td>
      <td><input type="text" formControlName="number_of_pieces" placeholder="{{ positions[0].number_of_pieces }}" class="clr-input" value="{{ positions[0].number_of_pieces }}"></td>
      <td><input type="text" formControlName="purchasing_price" placeholder="{{ positions[0].purchasing_price }}" class="clr-input" value="{{ positions[0].purchasing_price }}"></td>
      <td rowspan="5" class="btn-group btn-primary btn-icon">
        <button class="btn btn-sm" (click)="updateRequestsPosition()" [disabled]="editRequestsForm.invalid">
          <cds-icon shape="floppy"></cds-icon>
          <span class="clr-icon-title">Speichern</span>
        </button>
      </td>
    </tr>
    <tr *ngIf="positions[0].specification">
      <td colspan="3"></td>
      <td colspan="7" class="left"><b>Spezifikation:</b> {{ positions[0].specification }}</td>
    </tr>
    <tr *ngIf="positions[0].comment_phm">
      <td colspan="3"></td>
      <td colspan="7" class="left"><b>Kommentar:</b> {{ positions[0].comment_phm }}</td>
    </tr>
    <tr>
      <td colspan="3"></td>
      <td colspan="7" class="left">
        <div class="clr-form-control">
          <label for="remarks" class="clr-control-label">Leistungsumfang</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              <textarea formControlName="remarks" id="remarks" placeholder="{{ positions[0].remarks }}" cols="100" rows="10" class="clr-textarea" value="{{ positions[0].remarks }}"></textarea>
              <cds-icon class="clr-validate-icon" shape="exclamation-circle"></cds-icon>
            </div>
            <span class="clr-subtext">Dieses Feld erscheint im Dokument unter der Position.</span>
          </div>
        </div>
      </td>
    </tr>
    <tr>
      <td colspan="3"></td>
      <td colspan="7" class="left">
        <div class="clr-form-control">
          <label for="side_agreements" class="clr-control-label">Nebenabreden mit dem Lieferanten</label>
          <div class="clr-control-container">
            <div class="clr-textarea-wrapper">
              <textarea formControlName="side_agreements" id="side_agreements" placeholder="{{ positions[0].side_agreements }}" cols="100" rows="10" class="clr-textarea" value="{{ positions[0].side_agreements }}"></textarea>
              <cds-icon class="clr-validate-icon" shape="exclamation-circle"></cds-icon>
            </div>
            <span class="clr-subtext">Die Nebenabreden werden nach Beantwortung eines Requests ebenso wie der angebotene Preis erfasst und später bei einer eventuellen Order berücksichtigt.</span>
          </div>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</form>

<pre *ngIf="devMode" class="datepicker-output">
    {{ editRequestsForm.value | json }}
</pre>

